export default __webpack_public_path__ + "static/media/live-feed-loop.9b70afc7.svg";